export default __webpack_public_path__ + "static/media/icon_ui_warning-bg.1acf9934.png";